import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import cookie from "react-cookies";
import { listMyApplications } from "../../services/jobsApi";
import { TrainingLoading } from "../academy/AcademyShared";
import { APPLICATION_STATUS, EMPLOYMENT_LABELS, JobPill } from "../jobs/jobsShared";
import MeLayout from "./MeLayout";

export default function MeApplications() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!cookie.load("candidateKey")) {
      window.location.href = "/login?next=/me/applications";
      return;
    }
    listMyApplications()
      .then((res) => setApplications(res.applications || []))
      .catch((e) => setError(e.message || "Could not load your applications"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <MeLayout title="My applications" backTo="/academy">
      <div className="job-app">
        <p className="training-lead">
          Roles you have applied for, and where each one is. Finish any draft to send it to us.
        </p>

        {loading ? <TrainingLoading label="Loading your applications..." /> : null}
        {error ? <p className="job-app__error">{error}</p> : null}

        {!loading && !error && applications.length === 0 ? (
          <div className="training-empty">
            <p>You have not applied for anything yet. See what is open and apply in a few minutes.</p>
            <Link to="/jobs" className="training-btn-primary">
              See open positions
            </Link>
          </div>
        ) : null}

        <div className="job-app__list">
          {applications.map((app) => {
            const meta = APPLICATION_STATUS[app.status] || { label: app.status, tone: "slate" };
            return (
              <Link key={app.id} to={`/me/applications/${app.id}`} className="job-app__card">
                <div className="job-app__row">
                  <h3>{app.position?.title || "Position"}</h3>
                  <JobPill tone={meta.tone}>{meta.label}</JobPill>
                </div>
                <p>
                  {EMPLOYMENT_LABELS[app.position?.employment_type] || ""}
                  {app.position?.location ? ` · ${app.position.location}` : ""}
                </p>
                {app.status === "draft" ? <p>Draft. Open it to finish and send.</p> : null}
                {app.position?.status && app.position.status !== "open" && app.status === "draft" ? (
                  <p>This position has closed.</p>
                ) : null}
              </Link>
            );
          })}
        </div>
      </div>
    </MeLayout>
  );
}
